import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Login } from '../features/authentication/UI/pages/login'
import { UserDetails } from '../features/authentication/UI/pages/user-details'
import { Welcome } from '../features/authentication/UI/pages/welcome'
import { AchReceived } from '../features/collectionorder/UI/pages/ach-received'
import { NewSale } from '../features/collectionorder/UI/pages/new-sale'
import { TokenSent } from '../features/collectionorder/UI/pages/token-sent'
import { ClosureDetail } from '../features/dashboard/UI/pages/closure-detail'
import { CollectionOrderDetail } from '../features/dashboard/UI/pages/collection-order-detail'
import { JourneyInput } from '../features/journey/UI/pages/journey-input'
import { FinishJourney } from '../features/journey/UI/pages/finish-journey'
import { JourneyConcluded } from '../features/journey/UI/pages/journey-concluded'
import { DailySales } from '../features/dashboard/UI/pages/daily-sales'
import { Dashboard } from '../features/dashboard/UI/pages/dashboard'
import { PreviousClosings } from '../features/dashboard/UI/pages/previous-closings'
import { CreateUser } from '../features/user/UI/pages/create-user'
import { ConfirmNewPin } from '../features/user/UI/pages/reset-pin/confirm-new-pin'
import { CreateNewPin } from '../features/user/UI/pages/reset-pin/create-new-pin'
import { InformTaxId } from '../features/user/UI/pages/reset-pin/inform-tax-id'
import { ResetSuccess } from '../features/user/UI/pages/reset-pin/reset-success'
import { ValidateToken } from '../features/user/UI/pages/reset-pin/validate-token'
import { paths } from './paths'
import { ProtectedRouter } from './protected-router'
import { CreatePin } from '../features/user/UI/pages/create-pin'
import { ConfirmPin } from '../features/user/UI/pages/confirm-pin'
import { Concluded } from '../features/user/UI/pages/concluded'

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRouter />}>
        <Route
          path={paths.authentication.userDetails}
          element={<UserDetails />}
        />
        <Route path={paths.home} element={<Dashboard />} />
        <Route path={paths.dailySales} element={<DailySales />} />
        <Route path={paths.previousClosings} element={<PreviousClosings />} />
        <Route path={paths.closureDetail} element={<ClosureDetail />} />
        <Route
          path={paths.collectionOrderDetail}
          element={<CollectionOrderDetail />}
        />
        <Route path={paths.collectionOrder.newSale} element={<NewSale />} />
        <Route path={paths.collectionOrder.tokenSent} element={<TokenSent />} />
        <Route
          path={paths.collectionOrder.achReceived}
          element={<AchReceived />}
        />
        {/* Journey */}
        <Route path={paths.journey.input} element={<JourneyInput />} />
        <Route path={paths.journey.finish} element={<FinishJourney />} />
        <Route path={paths.journey.concluded} element={<JourneyConcluded />} />
        </Route>

        {/* Authentication */}
        <Route path={paths.authentication.welcome} element={<Welcome />} />
        <Route path={paths.authentication.login} element={<Login />} />

        

        {/* User */}
        <Route path={paths.user.createUser} element={<CreateUser />} />
        <Route path={paths.user.createPin} element={<CreatePin />} />
        <Route path={paths.user.confirmPin} element={<ConfirmPin />} />
        <Route path={paths.user.concluded} element={<Concluded />} />
        <Route
          path={paths.user.resetPassword.informTaxId}
          element={<InformTaxId />}
        />
        <Route
          path={paths.user.resetPassword.validateToken}
          element={<ValidateToken />}
        />
        <Route
          path={paths.user.resetPassword.createNewPin}
          element={<CreateNewPin />}
        />
        <Route
          path={paths.user.resetPassword.confirmNewPin}
          element={<ConfirmNewPin />}
        />
        <Route
          path={paths.user.resetPassword.resetSuccess}
          element={<ResetSuccess />}
        />
        <Route path={paths.user.concluded} element={<Concluded />} />
        {/* <Route path={paths.user.validateToken} element={<ValidateToken />} />
         */}

        <Route path={paths.home} element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  )
}
